export const SET_PRE_ORDER_SETTINGS = 'SET_PRE_ORDER_SETTINGS'
export const APPEND_PRE_ORDER_SETTINGS = 'APPEND_PRE_ORDER_SETTINGS'
export const SET_PRE_ORDER_SETTINGS_TOTAL = 'SET_PRE_ORDER_SETTINGS_TOTAL'
export const UPDATE_PRE_ORDER_SETTINGS_ROW = 'UPDATE_PRE_ORDER_SETTINGS_ROW'
